/**
 * Phase 18b — the List overrides editor's pure ops on the draft's array:
 * add a list (nothing overridden yet), patch one (its amount, or its gateway
 * pin — a LANE since Phase 40: routeId + gatewayRowId), drop one, and set or clear
 * one send option (an option set back to "container default" leaves the
 * object — an empty one becomes null, so the saved row stays clean).
 * For Media Devoted | Created By Ciro Autiero
 */
import type { DropGenListOverride, DropGenListOverrideOptions } from '@trafficpulse/shared';

type Key = keyof DropGenListOverrideOptions;

export function addOverride(list: DropGenListOverride[], wiserId: number): DropGenListOverride[] {
  if (list.some((o) => o.wiserId === wiserId)) return list;
  return [...list, { wiserId, amount: null, routeId: null, gatewayRowId: null, options: null }];
}

export function patchOverride(
  list: DropGenListOverride[],
  wiserId: number,
  patch: Partial<Pick<DropGenListOverride, 'amount' | 'routeId' | 'gatewayRowId'>>,
): DropGenListOverride[] {
  return list.map((o) => (o.wiserId === wiserId ? { ...o, ...patch } : o));
}

export function setOption<K extends Key>(
  list: DropGenListOverride[],
  wiserId: number,
  key: K,
  value: DropGenListOverrideOptions[K] | undefined,
): DropGenListOverride[] {
  return list.map((o) => {
    if (o.wiserId !== wiserId) return o;
    const next: DropGenListOverrideOptions = { ...(o.options ?? {}) };
    if (value === undefined) delete next[key];
    else next[key] = value;
    return { ...o, options: Object.keys(next).length > 0 ? next : null };
  });
}

export const removeOverride = (list: DropGenListOverride[], wiserId: number) => list.filter((o) => o.wiserId !== wiserId);
